import { render, staticRenderFns } from "./FormOtherFone.vue?vue&type=template&id=f2697342"
import script from "./FormOtherFone.vue?vue&type=script&lang=js"
export * from "./FormOtherFone.vue?vue&type=script&lang=js"
import style0 from "./FormOtherFone.vue?vue&type=style&index=0&id=f2697342&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports